import React from "react";
import ReactDOM from "react-dom";
import { HashRouter as Router } from "react-router-dom";


export default class FooterRouting {
    static _routes: any;
    static set routes(r) {
        this._routes = r;
    }

    static get routes() {
        return this._routes || [];
    }


    static getLanguage(language) {
        return (FooterRouting.routes.find(asset => asset.language === language) || {}).cmsassetid;
    }

    static processFooterRoutes(routeFile) {
        fetch(routeFile)
            .then(res => res.json())
            .then((routeData) => {

                Object.keys(routeData).forEach(function (key) {
                    const route = {
                        "language": routeData[key].language,
                        "cmsassetid": routeData[key].cmsassetid
                    };
                    FooterRouting.routes.push(route);
                });
            })
            .catch(console.log);
    }
}

FooterRouting.routes = [];
